var render = function render(){var _vm=this,_c=_vm._self._c;return _c('router-view',{key:_vm.routeViewKey,ref:"routePage"})
}
var staticRenderFns = []

export { render, staticRenderFns }